import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { HdfcProperties, useHdfcProperties } from "./HdfcProperties";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";
import { HdfcButton } from "./HdfcButton";
import { DraftHdfcButtonComponent } from "./DraftHdfcButtonComponent";

export const HdfcButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useHdfcProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <HdfcButton {...properties}
            className={className}>
            {children}
        </HdfcButton>
    )
}

Registry.addControl({
    id: "925ce40c-8356-4088-9f49-3ae2d5ccc7dc",
    name: "HDFC Button",
    type: ControlType.HdfcButton,
    properties: HdfcProperties,
    component: HdfcButtonComponent,
    draftComponent: DraftHdfcButtonComponent
})
